var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckInRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_95266)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1157 7.0487C16.5565 4.60792 20.5138 4.60792 22.9546 7.0487C25.3953 9.48948 25.3954 13.4468 22.9546 15.8875C21.3199 17.5222 19.0042 18.0637 16.9155 17.5059C16.4844 17.3908 16.0246 17.5142 15.7091 17.8297L13.598 19.9408L11.4641 19.9408C10.7737 19.9408 10.2141 20.5005 10.2141 21.1908V22.5925H8.81244C8.12208 22.5925 7.56244 23.1521 7.56244 23.8425V25.2441H4.75914L4.75914 21.7086L12.1736 14.2942C12.4891 13.9786 12.6125 13.5189 12.4974 13.0878C11.9396 10.999 12.481 8.6834 14.1157 7.0487ZM24.7223 5.28093C21.3053 1.86385 15.7651 1.86385 12.348 5.28093C10.2444 7.38456 9.43711 10.2922 9.92157 13.0106L2.99137 19.9408C2.52253 20.4097 2.25914 21.0456 2.25914 21.7086L2.25914 25.2441C2.25914 26.6249 3.37843 27.7441 4.75914 27.7441L8.81244 27.7441C9.14396 27.7441 9.4619 27.6124 9.69632 27.378C9.93074 27.1436 10.0624 26.8257 10.0624 26.4941V25.0925H11.4641C12.1544 25.0925 12.7141 24.5328 12.7141 23.8425L12.7141 22.4408L14.1157 22.4408C14.4473 22.4408 14.7652 22.3091 14.9996 22.0747L16.9926 20.0817C19.7111 20.5662 22.6187 19.7589 24.7223 17.6553C28.1394 14.2382 28.1394 8.69802 24.7223 5.28093ZM22.4392 10.9112C22.2005 10.1181 21.7685 9.39664 21.1821 8.81175C20.5956 8.22686 19.8731 7.79682 19.0793 7.56027C18.4177 7.3631 17.7215 7.73959 17.5244 8.40119C17.3272 9.06279 17.7037 9.75896 18.3653 9.95613C18.7622 10.0744 19.1235 10.2894 19.4167 10.5819C19.7099 10.8743 19.9259 11.235 20.0452 11.6316C20.2442 12.2927 20.9413 12.6673 21.6024 12.4684C22.2635 12.2694 22.6381 11.5723 22.4392 10.9112Z",
    fill: "#003D6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_95266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInRating);
export default __webpack_public_path__ + "static/media/check-in-rating.9a547601a0df021d3b7eb83d4ec5c1eb.svg";
export { ForwardRef as ReactComponent };